/**
 * Pricing section — shows free trial + two one-time credit pack options.
 */
import React from "react"
import { Box, Stack, Typography } from "@mui/material"
import Grid2 from "@mui/material/Grid2"
import { PRICING_SECTION } from "@/features/landing/content"
import PackCard from "@/features/billing/components/PackCard"
import { PAYMENT_OPTIONS } from "@/shared/constants/paymentCatalog"

const TRUST_BADGES = [
  { icon: "🔒", text: "Secure payments" },
  { icon: "🎯", text: "Credits never expire" },
  { icon: "🆓", text: "Free trial, no credit card required" },
  { icon: "🛡️", text: "Your data is never sold" }
]

export default function Pricing() {
  return (
    <Box
      id="pricing"
      sx={{ pt: { xs: 4, sm: 12 }, pb: { xs: 8, sm: 16 }, maxWidth: 1200, mx: "auto", px: { xs: 2, sm: 3, md: 5 } }}>
      <Typography variant="h4" align="center" gutterBottom fontWeight={700}>
        {PRICING_SECTION.heading}
      </Typography>
      <Typography variant="body1" align="center" color="text.secondary" sx={{ mb: 6 }}>
        {PRICING_SECTION.body}
      </Typography>

      <Grid2 container spacing={3} justifyContent="center" alignItems="stretch">
        {PAYMENT_OPTIONS.map(pack => (
          <Grid2 size={{ xs: 12, sm: 6, md: 4 }} key={pack.id} sx={{ display: "flex" }}>
            <PackCard pack={pack} loading={false} />
          </Grid2>
        ))}
      </Grid2>

      <Stack
        direction={{ xs: "column", sm: "row" }}
        justifyContent="center"
        alignItems="center"
        flexWrap="wrap"
        gap={{ xs: 1.5, sm: 3 }}
        sx={{ mt: 4 }}>
        {TRUST_BADGES.map(badge => (
          <Stack key={badge.text} direction="row" alignItems="center" spacing={0.75}>
            <Typography fontSize={16}>{badge.icon}</Typography>
            <Typography variant="caption" color="text.secondary" fontWeight={600}>
              {badge.text}
            </Typography>
          </Stack>
        ))}
      </Stack>
    </Box>
  )
}
